module.exports = __webpack_public_path__ + "static/media/cn.ce4c8db3.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/cn.svg
// module id = 623
// module chunks = 0